import React, { useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Loader() {
  return (
    <div className="grid min-h-screen place-items-center bg-slate-50">
      <div
        className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-[#720e1e]"
        aria-label="Loading"
      />
    </div>
  );
}

export default function PromoterRoute({ children }) {
  const location = useLocation();
  const {
    user,
    isAuthenticated,
    loading,
    authReady,
    adminAccessLoading,
    adminAccess,
  } = useAuth();
  const hasGrantedAccessRef = useRef(false);

  const roles = (adminAccess?.roles || []).map((role) =>
    String(role).trim().toLowerCase(),
  );
  const allowed =
    adminAccess?.is_promoter === true || roles.includes("promoter");

  if (user && allowed) {
    hasGrantedAccessRef.current = true;
  }

  const accessCheckPending = loading || !authReady || adminAccessLoading;

  if (accessCheckPending) {
    return hasGrantedAccessRef.current ? children : <Loader />;
  }

  if (!isAuthenticated || !user) {
    hasGrantedAccessRef.current = false;
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  if (allowed) {
    hasGrantedAccessRef.current = true;
    return children;
  }

  if (hasGrantedAccessRef.current && adminAccess == null) {
    return children;
  }

  hasGrantedAccessRef.current = false;
  return <Navigate to="/dashboard" replace />;
}
